require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./calculators-how-much-will-i-need-to-save-for-retirement.json") })
        }
      }, "path---calculators-how-much-will-i-need-to-save-for-retirement");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---calculators-how-much-will-i-need-to-save-for-retirement!./.cache/json/calculators-how-much-will-i-need-to-save-for-retirement.json
// module id = 1967
// module chunks = 231608221292675